"use strict";
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketEvents = void 0;
var WebSocketEvents;
(function (WebSocketEvents) {
    WebSocketEvents["Typing"] = "typing";
    WebSocketEvents["Posted"] = "posted";
    WebSocketEvents["PostEdited"] = "post_edited";
    WebSocketEvents["PostDeleted"] = "post_deleted";
    WebSocketEvents["PostUnread"] = "post_unread";
    WebSocketEvents["BurnOnReadPostRevealed"] = "post_revealed";
    WebSocketEvents["BurnOnReadPostBurned"] = "post_burned";
    WebSocketEvents["BurnOnReadPostAllRevealed"] = "burn_on_read_all_revealed";
    WebSocketEvents["ChannelConverted"] = "channel_converted";
    WebSocketEvents["ChannelCreated"] = "channel_created";
    WebSocketEvents["ChannelDeleted"] = "channel_deleted";
    WebSocketEvents["ChannelRestored"] = "channel_restored";
    WebSocketEvents["ChannelUpdated"] = "channel_updated";
    WebSocketEvents["ChannelMemberUpdated"] = "channel_member_updated";
    WebSocketEvents["ChannelSchemeUpdated"] = "channel_scheme_updated";
    WebSocketEvents["DirectAdded"] = "direct_added";
    WebSocketEvents["GroupAdded"] = "group_added";
    WebSocketEvents["NewUser"] = "new_user";
    WebSocketEvents["AddedToTeam"] = "added_to_team";
    WebSocketEvents["LeaveTeam"] = "leave_team";
    WebSocketEvents["UpdateTeam"] = "update_team";
    WebSocketEvents["DeleteTeam"] = "delete_team";
    WebSocketEvents["RestoreTeam"] = "restore_team";
    WebSocketEvents["UpdateTeamScheme"] = "update_team_scheme";
    WebSocketEvents["UserAdded"] = "user_added";
    WebSocketEvents["UserUpdated"] = "user_updated";
    WebSocketEvents["UserRoleUpdated"] = "user_role_updated";
    WebSocketEvents["MemberRoleUpdated"] = "memberrole_updated";
    WebSocketEvents["UserRemoved"] = "user_removed";
    WebSocketEvents["PreferenceChanged"] = "preference_changed";
    WebSocketEvents["PreferencesChanged"] = "preferences_changed";
    WebSocketEvents["PreferencesDeleted"] = "preferences_deleted";
    WebSocketEvents["EphemeralMessage"] = "ephemeral_message";
    WebSocketEvents["StatusChange"] = "status_change";
    WebSocketEvents["Hello"] = "hello";
    WebSocketEvents["AuthenticationChallenge"] = "authentication_challenge";
    WebSocketEvents["ReactionAdded"] = "reaction_added";
    WebSocketEvents["ReactionRemoved"] = "reaction_removed";
    WebSocketEvents["Response"] = "response";
    WebSocketEvents["EmojiAdded"] = "emoji_added";
    WebSocketEvents["MultipleChannelsViewed"] = "multiple_channels_viewed";
    WebSocketEvents["PluginStatusesChanged"] = "plugin_statuses_changed";
    WebSocketEvents["PluginEnabled"] = "plugin_enabled";
    WebSocketEvents["PluginDisabled"] = "plugin_disabled";
    WebSocketEvents["RoleUpdated"] = "role_updated";
    WebSocketEvents["LicenseChanged"] = "license_changed";
    WebSocketEvents["ConfigChanged"] = "config_changed";
    WebSocketEvents["OpenDialog"] = "open_dialog";
    WebSocketEvents["GuestsDeactivated"] = "guests_deactivated";
    WebSocketEvents["UserActivationStatusChange"] = "user_activation_status_change";
    WebSocketEvents["ReceivedGroup"] = "received_group";
    WebSocketEvents["ReceivedGroupAssociatedToTeam"] = "received_group_associated_to_team";
    WebSocketEvents["ReceivedGroupNotAssociatedToTeam"] = "received_group_not_associated_to_team";
    WebSocketEvents["ReceivedGroupAssociatedToChannel"] = "received_group_associated_to_channel";
    WebSocketEvents["ReceivedGroupNotAssociatedToChannel"] = "received_group_not_associated_to_channel";
    WebSocketEvents["GroupMemberDeleted"] = "group_member_deleted";
    WebSocketEvents["GroupMemberAdded"] = "group_member_add";
    WebSocketEvents["SidebarCategoryCreated"] = "sidebar_category_created";
    WebSocketEvents["SidebarCategoryUpdated"] = "sidebar_category_updated";
    WebSocketEvents["SidebarCategoryDeleted"] = "sidebar_category_deleted";
    WebSocketEvents["SidebarCategoryOrderUpdated"] = "sidebar_category_order_updated";
    WebSocketEvents["CloudSubscriptionChanged"] = "cloud_subscription_changed";
    WebSocketEvents["ThreadUpdated"] = "thread_updated";
    WebSocketEvents["ThreadFollowChanged"] = "thread_follow_changed";
    WebSocketEvents["ThreadReadChanged"] = "thread_read_changed";
    WebSocketEvents["FirstAdminVisitMarketplaceStatusReceived"] = "first_admin_visit_marketplace_status_received";
    WebSocketEvents["DraftCreated"] = "draft_created";
    WebSocketEvents["DraftUpdated"] = "draft_updated";
    WebSocketEvents["DraftDeleted"] = "draft_deleted";
    WebSocketEvents["PostAcknowledgementAdded"] = "post_acknowledgement_added";
    WebSocketEvents["PostAcknowledgementRemoved"] = "post_acknowledgement_removed";
    WebSocketEvents["PersistentNotificationTriggered"] = "persistent_notification_triggered";
    WebSocketEvents["HostedCustomerSignupProgressUpdated"] = "hosted_customer_signup_progress_updated";
    WebSocketEvents["ChannelBookmarkCreated"] = "channel_bookmark_created";
    WebSocketEvents["ChannelBookmarkUpdated"] = "channel_bookmark_updated";
    WebSocketEvents["ChannelBookmarkDeleted"] = "channel_bookmark_deleted";
    WebSocketEvents["ChannelBookmarkSorted"] = "channel_bookmark_sorted";
    WebSocketEvents["PresenceIndicator"] = "presence";
    WebSocketEvents["PostedNotifyAck"] = "posted_notify_ack";
    WebSocketEvents["ScheduledPostCreated"] = "scheduled_post_created";
    WebSocketEvents["ScheduledPostUpdated"] = "scheduled_post_updated";
    WebSocketEvents["ScheduledPostDeleted"] = "scheduled_post_deleted";
    WebSocketEvents["CPAFieldCreated"] = "custom_profile_attributes_field_created";
    WebSocketEvents["CPAFieldUpdated"] = "custom_profile_attributes_field_updated";
    WebSocketEvents["CPAFieldDeleted"] = "custom_profile_attributes_field_deleted";
    WebSocketEvents["CPAValuesUpdated"] = "custom_profile_attributes_values_updated";
    WebSocketEvents["ContentFlaggingReportValueUpdated"] = "content_flagging_report_value_updated";
    WebSocketEvents["RecapUpdated"] = "recap_updated";
    WebSocketEvents["PostTranslationUpdated"] = "post_translation_updated";
})(WebSocketEvents || (exports.WebSocketEvents = WebSocketEvents = {}));
